module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/join/step-screen-1-2bc07c8eaa875f3f5057d7f3412a5a92.png";